import React from 'react';
import PropTypes from 'prop-types';

import { Carousel } from 'dibs-carousel';
import { FollowingCarouselItem } from './FollowingCarouselItem';

import { trackImpressions, trackProductClick } from '../../helpers/trackingHelpers';
import { trackingLists, deviceTypes } from '../../constants';
import styles from './styles/followingCarousel.scss';

class FollowingCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.initiallyDisplayed = false;
        this.hasTrackingFired = {};

        this.handleContentVisible = this.handleContentVisible.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    handleContentVisible(itemsPerPage) {
        if (!this.initiallyDisplayed) {
            this.trackItemImpressions(itemsPerPage, 0);

            this.initiallyDisplayed = true;
        }
    }

    trackItemImpressions(itemsPerPage, page) {
        if (!this.hasTrackingFired[page]) {
            const { items } = this.props;
            const startIndex = page * itemsPerPage;
            const visibleItems = items.slice(startIndex, startIndex + itemsPerPage);

            trackImpressions(
                visibleItems.map((item, i) => {
                    return Object.assign({ index: startIndex + i + 1 }, item.node);
                }),
                trackingLists.FOLLOWING
            );

            this.hasTrackingFired[page] = true;
        }
    }

    handlePageChange(itemsPerPage, { page }) {
        /*
         * Needed for lazy images to load on swipe event.
         */
        this.forceUpdate();
        this.trackItemImpressions(itemsPerPage, page);
    }

    getItemsPerPage(deviceType) {
        switch (deviceType) {
            case deviceTypes.DESKTOP:
                return 6;
            case deviceTypes.MOBILE:
                return 2;
            default:
                return 4;
        }
    }

    render() {
        const { items, deviceType } = this.props;
        const itemsPerPage = this.getItemsPerPage(deviceType);

        return (
            <div className={styles.container} data-tn="following-carousel">
                <Carousel
                    totalItems={items.length}
                    itemsPerPage={itemsPerPage}
                    step={itemsPerPage}
                    renderItem={({ index }) => {
                        const { node: item } = items[index];
                        return (
                            <FollowingCarouselItem
                                onContentVisible={this.handleContentVisible.bind(
                                    this,
                                    itemsPerPage
                                )}
                                item={item}
                                onItemClick={() =>
                                    trackProductClick(item, trackingLists.FOLLOWING, index + 1)
                                }
                            />
                        );
                    }}
                    onPageChange={this.handlePageChange.bind(this, itemsPerPage)}
                />
            </div>
        );
    }
}

FollowingCarousel.defaultProps = {
    items: [],
};

FollowingCarousel.propTypes = {
    items: PropTypes.array,
    id: PropTypes.string,
    deviceType: PropTypes.string,
};

export default FollowingCarousel;
